export const Bold = 'bold';
export const Light = 'light';
export const Medium = 'medium';
